import React from "react";
import BottomNav from "./BottomNav";
import PainSOSButton from "./PainSOSButton";

export default function Layout({ children, hideNav = false, hideSOS = false }) {
  return (
    <div className="relative min-h-screen text-white">
      <div className="bps-ambient" />
      <div className="mx-auto w-full max-w-md min-h-screen pb-28 px-5 pt-6">
        {children}
      </div>
      {!hideNav && <BottomNav />}
      {!hideSOS && <PainSOSButton />}
    </div>
  );
}
